import { Prompt } from 'react-router-dom';

type NextLocation = { pathname: string; search: string; hash: string };

type Props = {
  /** Block in-app navigation while true. A function decides per destination. */
  when: boolean | ((nextLocation: NextLocation) => boolean);
  message: string;
};

/** Asks the user to confirm before they leave the page by in-app navigation. */
const UnsavedChangesPrompt = ({ when, message }: Props) => {
  // Like react-router's <Prompt when={false}>, do not register a history block when there is
  // nothing to lose: only one block can be active, so a clean prompt would replace a dirty one.
  if (when === false) return null;

  return (
    <Prompt
      message={nextLocation => {
        const shouldBlock = typeof when === 'function' ? when(nextLocation) : when;
        return shouldBlock ? message : true;
      }}
    />
  );
};

export default UnsavedChangesPrompt;
